var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass: "modal fade custom modal-open",
          attrs: { id: "list" + _vm.propId, role: "dialog" },
        },
        [
          _c("div", { staticClass: "modal-dialog modal-lg" }, [
            _c("div", { staticClass: "modal-content" }, [
              _vm._m(0),
              _c(
                "div",
                { staticClass: "modal-body headline-modal" },
                [
                  _c("div", [
                    _vm.headlines.length
                      ? _c("table", { staticClass: "table headlines-table" }, [
                          _c("thead", [
                            _c("tr", [
                              _c("th", { staticClass: "admin-col" }, [
                                _c("div", { staticClass: "checkbox" }, [
                                  _c("label", [
                                    _c("input", {
                                      attrs: { type: "checkbox" },
                                      domProps: { checked: _vm.selectedAll },
                                      on: {
                                        input: function ($event) {
                                          _vm.selectedAll =
                                            $event.target.checked
                                        },
                                        change: function ($event) {
                                          return _vm.checkList("all")
                                        },
                                      },
                                    }),
                                    _c("span", { staticClass: "cr" }),
                                  ]),
                                ]),
                              ]),
                              _c("th", { staticClass: "first-col" }),
                              _c("th", { staticClass: "w-50 w-48" }, [
                                _vm._v("Headline"),
                              ]),
                              _c("th", { staticClass: "w-3" }),
                              _c(
                                "th",
                                {
                                  staticClass: "pl-0",
                                  attrs: { width: "18%" },
                                },
                                [_vm._v("Headline Type")]
                              ),
                              _c("th", [_vm._v("Date")]),
                            ]),
                          ]),
                          _c(
                            "tbody",
                            _vm._l(_vm.headlines, function (record, index) {
                              return _c("tr", { key: index }, [
                                _c("td", { staticClass: "admin-col" }, [
                                  _c("div", { staticClass: "checkbox" }, [
                                    _c("label", [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.selectedItems,
                                            expression: "selectedItems",
                                          },
                                        ],
                                        attrs: { type: "checkbox" },
                                        domProps: {
                                          value: record.id,
                                          checked: Array.isArray(
                                            _vm.selectedItems
                                          )
                                            ? _vm._i(
                                                _vm.selectedItems,
                                                record.id
                                              ) > -1
                                            : _vm.selectedItems,
                                        },
                                        on: {
                                          change: [
                                            function ($event) {
                                              var $$a = _vm.selectedItems,
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false
                                              if (Array.isArray($$a)) {
                                                var $$v = record.id,
                                                  $$i = _vm._i($$a, $$v)
                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    (_vm.selectedItems =
                                                      $$a.concat([$$v]))
                                                } else {
                                                  $$i > -1 &&
                                                    (_vm.selectedItems = $$a
                                                      .slice(0, $$i)
                                                      .concat(
                                                        $$a.slice($$i + 1)
                                                      ))
                                                }
                                              } else {
                                                _vm.selectedItems = $$c
                                              }
                                            },
                                            function ($event) {
                                              return _vm.checkList()
                                            },
                                          ],
                                        },
                                      }),
                                      _c("span", { staticClass: "cr" }),
                                    ]),
                                  ]),
                                ]),
                                _c("td", { staticClass: "first-col" }, [
                                  _c(
                                    "div",
                                    { staticClass: "tableUpdateIcons" },
                                    [
                                      _c("span", {
                                        staticClass:
                                          "glyphicon glyphicon-pencil cursor-pointer edit_color",
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleRecord(record)
                                          },
                                        },
                                      }),
                                    ]
                                  ),
                                ]),
                                _c("td", { staticClass: "w-50" }, [
                                  _vm._v(_vm._s(record.title)),
                                ]),
                                _c("td", { staticClass: "w-3" }),
                                _c("td", { staticClass: "w-18" }, [
                                  _vm._v(
                                    " " + _vm._s(_vm.operations.type) + " "
                                  ),
                                ]),
                                _vm.operations.type === "Main Headline"
                                  ? _c("td", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm._f("dateFormat")(
                                              record.display_date
                                            )
                                          ) +
                                          " "
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm.operations.type === "Featured Content"
                                  ? _c("td", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm._f("dateFormat")(
                                              record.start_date
                                            )
                                          ) +
                                          " to " +
                                          _vm._s(
                                            _vm._f("dateFormat")(
                                              record.end_date
                                            )
                                          ) +
                                          " "
                                      ),
                                    ])
                                  : _vm._e(),
                              ])
                            }),
                            0
                          ),
                        ])
                      : _vm._e(),
                  ]),
                  _c("loader", { attrs: { loadingStatus: _vm.loaderStatus } }),
                ],
                1
              ),
              _c("div", { staticClass: "modal-footer" }, [
                _c(
                  "button",
                  {
                    staticClass:
                      "btn btn-modal-footer cancel cancel_button fl-lt",
                    attrs: { type: "button" },
                    on: { click: _vm.closeListPopUp },
                  },
                  [
                    _c("i", { staticClass: "fa fa-times-circle" }),
                    _vm._v(" Cancel "),
                  ]
                ),
                _c(
                  "button",
                  {
                    staticClass:
                      "btn btn-modal-footer submit_button fl-rt delete-btn",
                    attrs: {
                      type: "button",
                      disabled:
                        _vm.disablePublishChanges || !_vm.selectedItems.length,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.openDeletePopup()
                      },
                    },
                  },
                  [
                    _c("img", {
                      staticClass: "reg-headline-delete",
                      attrs: {
                        src: "/static/images/icons/delete_icon.svg",
                        alt: "delete-icon",
                      },
                    }),
                    _vm._v(" " + _vm._s(_vm.publishBtnTxt) + " "),
                  ]
                ),
              ]),
            ]),
          ]),
        ]
      ),
      _c("loader", { attrs: { loadingStatus: _vm.loaderStatus } }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-header" }, [
      _c("h4", { staticClass: "modal-title" }, [_vm._v(" Headlines List ")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }